import { DefaultRow } from "@pdf/helpers/default-row/default-row";
import { jsPDF } from "jspdf";

export class ZoneRow extends DefaultRow {
  readonly number: string[];
  readonly displayName: string[];
  readonly type: string[];
  readonly notes: string[];

  public constructor(pdf: jsPDF, number: string[], displayName: string[], type: string[], notes: string[]) {
    super();
    this.number = number;
    this.displayName = displayName;
    this.type = type;
    this.notes = notes;

    this._textHeight = this.calculateRowTextHeight(pdf);
    this._rowHeight = this.calculateRowHeight(this.textHeight);
  }

  public calculateRowTextHeight(pdf: jsPDF) {
    return Math.max(
      ...[
        this.calculateCellTextHeight(pdf, this.number),
        this.calculateCellTextHeight(pdf, this.displayName),
        this.calculateCellTextHeight(pdf, this.type),
        this.calculateCellTextHeight(pdf, this.notes),
      ],
    );
  }
}
